import { render, staticRenderFns } from "./LogSettings.vue?vue&type=template&id=537b7fff&scoped=true"
import script from "./LogSettings.vue?vue&type=script&lang=js"
export * from "./LogSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_cache-loader@4.1.0_webpack@4.47.0__css-load_b411938ae3dba6b80d9ee6ba07c3eefc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b7fff",
  null
  
)

export default component.exports